import React from 'react';
import Modal from './Modal';
import './SessionExpiredModal.css';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onClose?: () => void;
  onRedirect?: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
  isOpen,
  onClose,
  onRedirect
}) => {
  // CRÍTICO: Si estamos en login o no hay usuario, NO mostrar el modal
  const user = localStorage.getItem('user');
  const isOnLoginPage = window.location.pathname === '/login' || window.location.pathname === '/' || window.location.pathname.includes('login');
  const logoutTimestamp = sessionStorage.getItem('logoutTimestamp');
  const justLoggedOut = logoutTimestamp && (Date.now() - parseInt(logoutTimestamp)) < 10000;
  
  // Si no hay usuario, estamos en login, o acabamos de hacer logout, NO mostrar el modal
  if (!user || isOnLoginPage || justLoggedOut) {
    if (onClose) {
      onClose();
    }
    return null;
  }
  
  const handleRedirect = () => {
    // Establecer logoutTimestamp para evitar que el modal aparezca después de redirigir
    sessionStorage.setItem('logoutTimestamp', Date.now().toString());
    
    if (onRedirect) {
      onRedirect();
    } else {
      // Usar window.location.href en lugar de useNavigate para evitar problemas con Router context
      window.location.href = '/login';
      return; // No ejecutar onClose porque la página se va a recargar
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleRedirect}
      title="Sesión expirada"
      onConfirm={handleRedirect}
      confirmText="Ir al inicio de sesión"
      cancelText=""
    >
      <div className="session-expired-content">
        <p>
          Tu sesión ha expirado por seguridad. Por favor, inicia sesión nuevamente para continuar.
        </p>
        <p className="session-expired-hint">
          Todos tus cambios no guardados se han perdido. Te recomendamos guardar frecuentemente.
        </p>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
